import { render, staticRenderFns } from "./WizardContentImageCaptureInput.vue?vue&type=template&id=5740d1eb&scoped=true&"
import script from "./WizardContentImageCaptureInput.vue?vue&type=script&lang=ts&"
export * from "./WizardContentImageCaptureInput.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentImageCaptureInput.vue?vue&type=style&index=0&id=5740d1eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5740d1eb",
  null
  
)

export default component.exports